import { Injectable } from '@angular/core';
import { UsersApp } from '../models/usersApp.model';
import { AngularFirestoreDocument, AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  database = 'UsersApp';
  databaseTrash = 'UsersAppTrash';
  roomEscapeDoc: AngularFirestoreDocument<UsersApp>;
  constructor(
    private afs: AngularFirestore) { }


  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  } get ref() {
    return firebase.firestore().collection(this.database);
  }

  create(user: UsersApp) {
    user.id = user.email;
    return this.ref.firestore.doc(this.database + '/' + user.id).set(Object.assign({}, user));
  }
  edit(user: UsersApp) {
    return this.ref.firestore.doc(this.database + '/' + user.id).set(Object.assign({}, user));
  }
  remove(user: UsersApp) {
    this.ref.firestore.doc(this.databaseTrash + '/' + user.id).set(Object.assign({}, user));
    return this.ref.firestore.doc(this.database + '/' + user.id).delete();
  }
  getAll() {
    return this.afs.collection<UsersApp>(this.database, ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
        query = query.orderBy('lastConnection', 'desc');
        return query;
    }).snapshotChanges().pipe(map(actions => actions.map(a => {
      return a.payload.doc.data();
    })));
  }
}
